import { Component, Input, AfterViewInit, OnInit } from "@angular/core";
import { MasterdataService } from "@core-services/masterdata.service";
import { FiatService } from "@main-services/currency";
import { Fiat, FiatWallet, Provider, Sepa } from "@models";
import { UserService } from "@main-services/user.service";
import { SepaQrTileData } from "@modules/main/components/sepa-qr-new/sepa-qr-tile-new/models/sepa-qr-tile-data.model";
import { SepaQrFacade } from "@modules/main/components/sepa-qr-new/domain/+state/sepa-qr.facade";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { FIAT_EURO_ID } from "@helpers/constants";

@UntilDestroy()
@Component({
	selector: "sepa-qr-new",
	templateUrl: "./sepa-qr-new.component.html",
	styleUrls: ["./sepa-qr-new.component.scss"],
	providers: [SepaQrFacade],
	// TODO - OnPush - old logic needs many CD cycles to show correct data.. - will be improved after moving (and refactoring) this component (and logic) to Payments Module
	standalone: false
})
// TODO: will be refactored and moved to PaymentsModule in next 2-3 sprints (new models, etc)
export class SepaQrNewComponent implements OnInit, AfterViewInit {
	public tiles: SepaQrTileData[] = [];
	public referenceNumberTiles: SepaQrTileData[] = [];
	public isFiatEuro: boolean = false;
	public isGBPBankTransfer: boolean = false;

	public constructor(
		private masterdataService: MasterdataService,
		private fiatService: FiatService,
		private userService: UserService,
		private readonly sepaQrFacade: SepaQrFacade
	) {}

	@Input()
	public wallet: FiatWallet = null;
	@Input()
	public amount: number = 0;
	@Input()
	public provider: Provider = null;
	@Input()
	public sendEmail: boolean = false;

	public ngOnInit(): void {
		this.masterdataService
			.getSepas$()
			.pipe(untilDestroyed(this))
			.subscribe((sepas: Sepa[]) => {
				const sepa = sepas?.find((s: Sepa) => s.getId() === this.fiat.getId());
				this.isGBPBankTransfer = sepa?.isGBPBankTransfer();
				this.tiles = this.sepaQrFacade.getSepaQrTilesData(sepa, this.isGBPBankTransfer);
			});

		this.referenceNumberTiles = this.sepaQrFacade.getReferenceNumberTilesData(this.paymentReference);
		this.isFiatEuro = this.fiat.getId() === FIAT_EURO_ID;
	}

	public ngAfterViewInit(): void {
		if (this.provider) {
			this.masterdataService.getSepaForFiatId(
				this.fiat.getId(),
				this.provider.getId(),
				this.userService.user.getId(),
				this.amount,
				this.sendEmail
			);
		}
	}

	public get qrValue(): string {
		const amount = this.amount === 0 ? "" : this.fiat.getSymbol() + this.amount;
		let value = "BCD\n001\n1\nSCT\n";
		value += this.sepa.getBic() + "\n" + this.sepa.getReceiver() + "\n" + this.sepa.getIban();
		value += "\n" + amount + "\n\n" + this.paymentReference;
		return value;
	}

	public get paymentReference(): string {
		return this.userService.user.getPaymentReference();
	}

	public get sepa(): Sepa {
		return this.masterdataService.getSepas().find((s: Sepa) => s.getId() === this.fiat.getId());
	}

	public get fiat(): Fiat {
		return this.fiatService.getItemById(this.wallet.getFiatId());
	}

	// TODO: move this check to parents, so this component is not loaded unnecessarily when false
	public show(): boolean {
		return !!this.wallet && !!this.sepa;
	}
}
